/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GetAllUserRoles, RegisterUser } from "../../API/Pins";

import Input from "../Input";
import Select from "../Select";

const AddUserModal = ({ refetchData, closeModal }) => {
  const [UserName, setUserName] = useState("");
  const [Password, setPassword] = useState("");
  const [Email, setEmail] = useState("");
  const [Role, setRole] = useState("");
  const [RolesList, setRolesList] = useState({});
  const [RegisterUserApiState, setRegisterUserApiState] = useState({
    res: null,
    loading: null,
  });

  useEffect(() => {
    if (RegisterUserApiState.res) {
      refetchData();
      closeModal();
    }
  }, [RegisterUserApiState.res]);

  const handleRegisterUser = async () => {
    try {
      setRegisterUserApiState({
        res: null,
        loading: true,
      });
      await RegisterUser({
        username: UserName,
        email: Email,
        password: Password,
        role_id: Role,
        is_active: true,
      });
      setRegisterUserApiState({
        res: true,
        loading: false,
      });
    } catch (error) {
      setRegisterUserApiState({
        err: error,
        res: null,
        loading: false,
      });
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await GetAllUserRoles();
      const roles = {};
      res.data.forEach((item) => (roles[item.uuid] = item.role));
      setRolesList(roles);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className="flex flex-col items-center gap-3 px-8 py-6 w-[780px] relative">
      <div className="flex items-center justify-evenly gap-4 w-full">
        <div className="w-full">
          <Input
            label="Username"
            onChange={(val) => setUserName(val)}
            value={UserName}
          />
        </div>

        <div className="w-full">
          <Input
            label="Email"
            onChange={(val) => setEmail(val)}
            value={Email}
          />
        </div>
      </div>
      <div className="flex items-center justify-evenly gap-4 flex-grow w-full">
        <div className="w-full">
          <Input
            label="Password"
            onChange={(val) => setPassword(val)}
            value={Password}
          />
        </div>
        <div className="w-full">
          <Select
            label="Role"
            options={RolesList}
            onChange={(val) => setRole(val.key)}
            value={Role}
          />
        </div>
      </div>

      <button
        disabled={
          !UserName ||
          !Password ||
          !Email ||
          !Role ||
          RegisterUserApiState.loading
        }
        className="px-3 py-1 m-auto text-center cursor-pointer mt-5 disabled:cursor-no-drop disabled:opacity-30"
        onClick={handleRegisterUser}
      >
        Submit
      </button>
      {RegisterUserApiState.err && (
        <div className="absolute bottom-5 right-4 text-sm text-red-error">
          {RegisterUserApiState.err?.response?.data?.detail[0]?.msg ||
            RegisterUserApiState.err?.response?.data?.detail}
        </div>
      )}
    </div>
  );
};

export default AddUserModal;
